import type {
  BuyflowWidget,
  CpePointsWidget,
  GetNextBuyflowStepResponse,
} from '@/lib/TypesOpenApi';
import {proxy} from 'valtio';
import {
  type StepWidgetStore,
  StepsPath,
  stepsMap,
} from '../routing/StepsRouting';
import {useWidget} from '../routing/StepsWizardContext';

const widget = stepsMap['POINT_SELECTOR']!.store;

export interface PointSelectorPageWidget {
  /** Base widget to relay on */
  widget: StepWidgetStore;
  content?: GetNextBuyflowStepResponse;
  productWidget?: CpePointsWidget;

  minCount: number;
  maxCount: number;
  includedCount: number;
}

export const pointSelectorWidget = proxy<PointSelectorPageWidget>({
  widget,
  get content() {
    return this.widget.content;
  },

  get productWidget() {
    const widgets =
      this.content?.buyflowStep.buyflowWidgets
        ?.map(({cpePointsWidget: w}: BuyflowWidget) => w!)
        .filter((w: BuyflowWidget) => !!w) || [];
    return widgets[0];
  },

  get minCount() {
    return this.productWidget?.minCount || 0;
  },

  get maxCount() {
    return this.productWidget?.maxCount || 0;
  },

  get includedCount() {
    return this.productWidget?.includedCount || 0;
  },
});

export const usePointSelectorWidget = () =>
  useWidget(StepsPath.PointSelector, pointSelectorWidget);
